<pmt-action-modal 
    [title]="'assignments.information.cancelSubstituteSearch' | transloco" 
    [submitButtonIconCode]="''"
    [submitButtonText]="'modal.confirmButton' | transloco" 
    (submitted)="cancelAssignmentSubstitudeSearch()"
    class="custom-modal-limiter"
    [isSaving]="isLoading"
    >
    <div class="d-flex flex-column gap-3">
        <div class="alert alert-warning">
            <p>{{'assignments.information.cancelSubstituteSearchAlert' | transloco }}</p>
        </div>
        <ng-container *ngIf="isError">
            <p class="text-danger" *ngIf="errorMessage == null">{{'generalError' | transloco}}</p>
            <p class="text-danger" *ngIf="errorMessage != null">{{errorMessage}}</p>
        </ng-container>
    </div>

</pmt-action-modal>